import React from 'react';

interface LedgerBugProps {
  /** Square size in pixels. */
  size?: number;
  className?: string;
}

/**
 * The Ledger Bug — 2G1P's bet-slip-stub logo mark. Fill/ink flip with the
 * site's day/night edition (via CSS vars); the coral spine + "1P" stay the
 * literal brand hex in both editions, matching the brand kit reference.
 */
const LedgerBug: React.FC<LedgerBugProps> = ({ size = 48, className = '' }) => {
  // Below ~32px the offset shadow reads as mud rather than depth — drop it.
  const showShadow = size >= 32;

  return (
    <span
      className={`ledger-bug ${className}`.trim()}
      style={{ '--bug-size': `${size}px` } as React.CSSProperties}
      data-shadow={showShadow}
      aria-hidden="true"
    >
      <span className="ledger-bug__spine" />
      <span className="ledger-bug__row ledger-bug__row--top">
        <span className="ledger-bug__digit">2</span>
        <span>G</span>
      </span>
      <span className="ledger-bug__row ledger-bug__row--bottom">
        <span className="ledger-bug__digit">1</span>
        <span>P</span>
      </span>
    </span>
  );
};

export default LedgerBug;
